export const plaidModal = {
  maxHeight: 608,
  height: '100%',
  width: 360,
  borderRadius: 8,
};
